var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44163 6.69215C5.32444 6.80919 5.16558 6.87493 4.99996 6.87493C4.83433 6.87493 4.67548 6.80919 4.55829 6.69215L2.20079 4.33548C2.0836 4.21824 2.01778 4.05923 2.01782 3.89346C2.01786 3.72769 2.08375 3.56872 2.201 3.45152C2.31825 3.33433 2.47725 3.26852 2.64302 3.26855C2.8088 3.26859 2.96777 3.33448 3.08496 3.45173L4.99996 5.36673L6.91496 3.45173C7.03278 3.33783 7.19063 3.27476 7.3545 3.2761C7.51838 3.27745 7.67517 3.3431 7.7911 3.45893C7.90704 3.57476 7.97284 3.73148 7.97434 3.89536C7.97584 4.05923 7.91292 4.21714 7.79913 4.33507L5.44163 6.69215Z",
    fill: "#576265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsc);
export default __webpack_public_path__ + "static/media/asc.b9fcbef3c33492124c99f1efcbcc012e.svg";
export { ForwardRef as ReactComponent };